import React, { useCallback, useEffect, useState } from 'react';
import {
  View,
  Text,
  TouchableOpacity,
  TextInput,
  Image,
  ScrollView,
  RefreshControl,
} from 'react-native';
import { FloatingAction } from 'react-native-floating-action';
import CurrencyInput from 'react-native-currency-input';

import moment from 'moment';

import api from '../services/api';
import formatCurrency from '../utils/formatCurrency';

import 'react-date-picker/dist/DatePicker.css';
import 'react-calendar/dist/Calendar.css';
import CidadesComponent from '../components/CidadesComponent';

const Sorteios = ({ navigation }) => {
  const [sorteiosAbertos, setSorteiosAbertos] = useState([]);
  const [sorteiosFechados, setSorteiosFechados] = useState([]);
  const [ver, setVer] = useState('ABERTOS');
  const [refreshing, setRefreshing] = useState(false);

  const [usuario, setUsuario] = useState(null);

  const [cartela, setCartela] = useState(null);
  const [nome, setNome] = useState('');
  const [cidade, setCidade] = useState('');
  const [valor, setValor] = React.useState(0);
  const [dataSorteio, setDataSorteio] = useState(new Date());
  const [loading, setLoading] = useState(false);
  const [paginaCadastro, setPaginaCadastro] = useState(false);

  const handleConsultarSorteios = useCallback(async () => {
    try {
      const { data } = await api.get('sorteios');
      const s = data.reverse();
      setSorteiosFechados(s.filter((sorteio) => sorteio.situacao != 'ATIVO'));
      setSorteiosAbertos(s.filter((sorteio) => sorteio.situacao == 'ATIVO'));
      setLoading(false);
    } catch (e) {
      console.log(e);
    }
  }, []);

  useEffect(() => {
    const unsubscribe = navigation.addListener('focus', () => {
      setLoading(true);

      let user = localStorage.getItem('user');

      if (user) {
        user = JSON.parse(user);

        setUsuario(user);
        handleConsultarSorteios();
      }
    });

    return unsubscribe;
  }, []);

  const refresh = () => {
    location.reload();
  };

  const abrirCadastro = () => {
    setCartela(null);
    setNome('');
    setCidade('');
    if (usuario.tipo == 'GERENTE') {
      setCidade(usuario.cidade?.id ?? usuario.cidade ?? null);
    }
    setPaginaCadastro(true);
  };

  const voltarPaginaInicial = () => {
    const x = confirm('Deseja realmente voltar?');
    if (x) {
      setPaginaCadastro(false);
    }
  };

  const handleChangeCidade = (cidade) => {
    setCidade(cidade);
  };

  const salvarSorteio = async () => {
    const confirmar = confirm('Deseja realmente salvar o sorteio?');
    if (!confirmar) return;

    try {
      if (!(valor > 0)) {
        alert('O valor da cartela deve ser maior que 0');
        return;
      }

      if (nome.trim().length < 3) {
        alert('Nome do sorteio deve conter pelo menos 3 dígitos.');
        return;
      }

      if (!cidade) {
        alert('Selecione a cidade do sorteio.');
        return;
      }

      if (cartela == null) {
        alert('Selecione o modelo de cartelas.');
        return;
      }

      const dataSorteioStr =
        typeof dataSorteio === 'string'
          ? dataSorteio
          : new Date(dataSorteio).toISOString().slice(0, 10);

      const dados = {
        nome,
        cidade: cidade,
        quantidade: cartela,
        dataSorteio: dataSorteioStr,
        cidade_id: cidade,
        quantidade_chance: cartela,
        data_realizar_sorteio: dataSorteioStr,
        valor_cartela: valor,
      };

      await api.post('sorteios', dados);
      handleConsultarSorteios();
      setPaginaCadastro(false);
    } catch (err) {
      alert('Falha ao cadastrar sorteio, por favor verifique todos os campos.');
    }
  };

  const excluirSorteio = (e) => {
    const x = confirm('Deseja realmente excluir este sorteio?');
    if (x) {
      api.delete(`excluirsorteio/${e.id}`).then(() => {
        alert('Sorteio excluido com sucesso!');
        handleConsultarSorteios();
      });
    }
  };

  const onRefresh = React.useCallback(() => {
    setRefreshing(true);
    setTimeout(() => {
      setRefreshing(false);
    }, 2000);
  }, []);

  if (!usuario) {
    return null;
  }

  if (paginaCadastro) {
    return (
      <View style={{ flex: 1 }}>
        <View style={{ margin: 20, flex: 1 }}>
          <View
            style={{
              backgroundColor: '#fff',
              padding: 10,
              marginTop: 10,
              borderRadius: 5,
            }}
          >
            <Text style={{ fontSize: 12 }}>Nome do sorteio</Text>
            <TextInput
              style={{
                paddingTop: 5,
                marginTop: 5,
                paddingBottom: 5,
                paddingLeft: 5,
                borderWidth: 1,
                borderColor: '#000',
                borderRadius: 5,
              }}
              value={nome}
              onChangeText={setNome}
            />

            <Text style={{ fontSize: 12, marginTop: 10 }}>Cidade</Text>
            <CidadesComponent
              disabled={usuario.tipo == 'GERENTE'}
              value={cidade}
              handleChange={handleChangeCidade}
            />

            <Text style={{ fontSize: 12, marginTop: 10 }}>R$ Valor</Text>
            <CurrencyInput
              style={{
                paddingTop: 5,
                marginTop: 5,
                paddingBottom: 5,
                paddingLeft: 5,
                borderWidth: 1,
                borderColor: '#000',
                borderRadius: 5,
              }}
              value={valor}
              onChangeValue={setValor}
            />

            <Text style={{ fontSize: 12, marginTop: 10 }}>Modelo cartela</Text>

            <View
              style={{ display: 'flex', flexDirection: 'row', marginTop: 5 }}
            >
              <TouchableOpacity
                onPress={() => setCartela(3)}
                style={{ flex: 1, marginRight: 5 }}
              >
                <Text
                  style={{
                    padding: 5,
                    textAlign: 'center',
                    backgroundColor: cartela == 3 ? '#1abc9c' : '#bdc3c7',
                    borderRadius: 5,
                    color: cartela == 3 ? '#fff' : '#000',
                  }}
                >
                  3 chances
                </Text>
              </TouchableOpacity>

              <TouchableOpacity
                onPress={() => setCartela(4)}
                style={{ flex: 1, marginLeft: 5 }}
              >
                <Text
                  style={{
                    padding: 5,
                    textAlign: 'center',
                    backgroundColor: cartela == 4 ? '#1abc9c' : '#bdc3c7',
                    borderRadius: 5,
                    color: cartela == 4 ? '#fff' : '#000',
                  }}
                >
                  4 chances
                </Text>
              </TouchableOpacity>
            </View>

            <Text style={{ fontSize: 12, marginTop: 10 }}>Data do sorteio</Text>
            <input
              value={dataSorteio}
              onChange={(e) => setDataSorteio(e.target.value)}
              type="date"
              style={{ marginLeft: 1, padding: 5, textAlign: 'center' }}
            />
          </View>

          <View
            style={{ display: 'flex', flexDirection: 'row', marginTop: 25 }}
          >
            <TouchableOpacity
              onPress={() => voltarPaginaInicial()}
              style={{ flex: 1, marginRight: 5 }}
            >
              <Text
                style={{
                  padding: 5,
                  textAlign: 'center',
                  backgroundColor: '#bdc3c7',
                  borderRadius: 5,
                }}
              >
                Voltar
              </Text>
            </TouchableOpacity>

            <TouchableOpacity
              onPress={() => salvarSorteio()}
              style={{ flex: 1, marginLeft: 5 }}
            >
              <Text
                style={{
                  padding: 5,
                  textAlign: 'center',
                  backgroundColor: '#1abc9c',
                  color: '#fff',
                  borderRadius: 5,
                }}
              >
                Salvar
              </Text>
            </TouchableOpacity>
          </View>
        </View>
      </View>
    );
  }

  return (
    <View style={{ flex: 1 }}>
      <View style={{ margin: 20, marginBottom: 0, flex: 1 }}>
        <View style={{ flexDirection: 'row' }}>
          {refreshing != true ? (
            <TouchableOpacity
              style={{ marginRight: 5 }}
              onPress={() => refresh()}
            >
              <Text
                style={{
                  textAlign: 'center',
                  backgroundColor: ver == 'ABERTOS' ? '#1abc9c' : '#1abc9c',
                  color: ver == 'ABERTOS' ? '#fff' : '#fff',
                  padding: 5,
                  borderRadius: 5,
                }}
              >
                Atualizar
              </Text>
            </TouchableOpacity>
          ) : null}
          {usuario.tipo == 'ADMIN' || usuario.tipo == 'GERENTE' ? (
            <TouchableOpacity
              style={{ flex: 1, marginRight: 5 }}
              onPress={() => setVer('ABERTOS')}
            >
              <Text
                style={{
                  textAlign: 'center',
                  backgroundColor: ver == 'ABERTOS' ? '#3498db' : null,
                  color: ver == 'ABERTOS' ? '#fff' : null,
                  padding: 5,
                  borderRadius: 5,
                }}
              >
                Abertos
              </Text>
            </TouchableOpacity>
          ) : null}

          {usuario.tipo == 'ADMIN' || usuario.tipo == 'GERENTE' ? (
            <TouchableOpacity
              style={{ flex: 1, marginLeft: 5 }}
              onPress={() => setVer('FECHADOS')}
            >
              <Text
                style={{
                  textAlign: 'center',
                  backgroundColor: ver == 'FECHADOS' ? '#3498db' : null,
                  color: ver == 'FECHADOS' ? '#fff' : null,
                  padding: 5,
                  borderRadius: 5,
                }}
              >
                Fechados
              </Text>
            </TouchableOpacity>
          ) : null}
        </View>

        <ScrollView
          style={{ paddingTop: 10, paddingBottom: 50 }}
          refreshControl={
            <RefreshControl refreshing={refreshing} onRefresh={onRefresh} />
          }
        >
          {loading ? (
            <View
              style={{
                backgroundColor: '#fff',
                padding: 10,
                marginTop: 10,
                borderRadius: 5,
                alignItems: 'center',
              }}
            >
              <Image
                style={{ height: 32, width: 32 }}
                source={require('../assets/loading.gif')}
              />
            </View>
          ) : ver == 'ABERTOS' ? (
            sorteiosAbertos.length > 0 ? (
              sorteiosAbertos.map((e) => (
                <View>
                  <View
                    style={{
                      backgroundColor: '#fff',
                      padding: 10,
                      marginTop: 10,
                      borderRadius: 5,
                    }}
                  >
                    <View style={{ flexDirection: 'row' }}>
                      <Text style={{ flex: 1, fontWeight: 'bold' }}>
                        {e.nome}
                      </Text>
                      <Text style={{}}>{e.cidade.nome}</Text>
                    </View>
                    <View style={{ flexDirection: 'row', marginTop: 10 }}>
                      <View style={{ flex: 1, flexDirection: 'row' }}>
                        <Text style={{ fontWeight: 'bold' }}>
                          {usuario.tipo == 'VENDEDOR'
                            ? 'Total vendido'
                            : 'Qtd vendida'}
                          :
                        </Text>
                        <Text>
                          {' '}
                          {usuario.tipo == 'VENDEDOR'
                            ? `R$ ${formatCurrency(
                                e.valor_cartela * e.quantidade_vendido
                              )}`
                            : e.quantidade_vendido}
                        </Text>
                      </View>

                      <View style={{ flex: 1, flexDirection: 'row' }}>
                        <Text style={{ fontWeight: 'bold', paddingRight: 5 }}>
                          Valor cartela:
                        </Text>
                        <Text>R$ {formatCurrency(e.valor_cartela)}</Text>
                      </View>
                    </View>
                    <View style={{ flexDirection: 'row', marginTop: 10 }}>
                      <View style={{ flex: 1, flexDirection: 'row' }}>
                        <Text style={{ fontWeight: 'bold' }}>Modelo:</Text>
                        <Text> {e.quantidade_chance} chances</Text>
                      </View>

                      <View style={{ flex: 1, flexDirection: 'row' }}>
                        <Text style={{ fontWeight: 'bold' }}>
                          {usuario.tipo == 'VENDEDOR' ||
                          usuario.tipo == 'GERENTE'
                            ? 'Qtd vendida'
                            : 'Vendedores'}
                          :
                        </Text>
                        <Text>
                          {' '}
                          {usuario.tipo == 'VENDEDOR' ||
                          usuario.tipo == 'GERENTE'
                            ? e.quantidade_vendido
                            : e.quantidade_vendedores}
                        </Text>
                      </View>
                    </View>

                    {(usuario.tipo == 'ADMIN' || usuario.tipo == 'GERENTE') && (
                      <View
                        style={{ flex: 1, flexDirection: 'row', marginTop: 10 }}
                      >
                        <Text style={{ fontWeight: 'bold' }}>
                          Total vendido:
                        </Text>
                        <Text>
                          {' '}
                          R${' '}
                          {formatCurrency(
                            e.valor_cartela * e.quantidade_vendido
                          )}
                        </Text>
                      </View>
                    )}

                    <View style={{ flexDirection: 'row', marginTop: 10 }}>
                      <TouchableOpacity
                        style={{ flex: 1, marginRight: 10 }}
                        onPress={() =>
                          usuario.tipo == 'ADMIN' || usuario.tipo == 'GERENTE'
                            ? navigation.navigate('Clientes', { sorteio: e })
                            : navigation.navigate('Clientes', {
                                vendedor_id: usuario.id,
                                sorteio: e,
                              })
                        }
                      >
                        <Text
                          style={{
                            textAlign: 'center',
                            fontSize: 12,
                            padding: 5,
                            borderRadius: 5,
                            background: '#1abc9c',
                            color: '#FFF',
                          }}
                        >
                          Clientes
                        </Text>
                      </TouchableOpacity>

                      <TouchableOpacity
                        style={{ flex: 1, marginLeft: 10 }}
                        onPress={() =>
                          usuario.tipo == 'ADMIN' || usuario.tipo == 'GERENTE'
                            ? navigation.navigate('SorteioDetalhe', {
                                sorteio: e,
                              })
                            : navigation.navigate('VenderCartela', {
                                vendedor_id: usuario.id,
                                sorteio: e,
                                statusVenda: e.situacao_venda,
                              })
                        }
                      >
                        <Text
                          style={{
                            textAlign: 'center',
                            fontSize: 12,
                            padding: 5,
                            borderRadius: 5,
                            background: '#1abc9c',
                            color: '#FFF',
                          }}
                        >
                          Cartelas
                        </Text>
                      </TouchableOpacity>

                      {(usuario.tipo == 'ADMIN' ||
                        usuario.tipo == 'GERENTE') && (
                        <TouchableOpacity
                          style={{ flex: 1, marginLeft: 10 }}
                          onPress={() =>
                            navigation.navigate('SorteioManuntencao', {
                              sorteio_id: e.id,
                            })
                          }
                        >
                          <Text
                            style={{
                              textAlign: 'center',
                              fontSize: 12,
                              padding: 5,
                              borderRadius: 5,
                              background: '#e74c3c',
                              color: '#FFF',
                            }}
                          >
                            Manuntenção
                          </Text>
                        </TouchableOpacity>
                      )}
                    </View>
                  </View>
                </View>
              ))
            ) : (
              <View
                style={{
                  backgroundColor: '#fff',
                  padding: 10,
                  marginTop: 10,
                  borderRadius: 5,
                  flexDirection: 'row',
                }}
              >
                <Text style={{ flex: 1, textAlign: 'center' }}>
                  Nenhum sorteio aberto
                </Text>
              </View>
            )
          ) : sorteiosFechados.length > 0 ? (
            sorteiosFechados.map((e) => (
              <View>
                <View
                  style={{
                    backgroundColor: '#fff',
                    padding: 10,
                    marginTop: 10,
                    borderRadius: 5,
                  }}
                >
                  <View style={{ flexDirection: 'row' }}>
                    <Text style={{ flex: 1, fontWeight: 'bold' }}>
                      {e.nome}
                    </Text>
                    <Text style={{}}>{e.cidade.nome}</Text>
                  </View>
                  <View style={{ flexDirection: 'row', marginTop: 10 }}>
                    <View style={{ flex: 1, flexDirection: 'row' }}>
                      <Text style={{ fontWeight: 'bold' }}>Cadastro:</Text>
                      <Text> {moment(e.created_at).format('DD/MM/YYYY')}</Text>
                    </View>

                    <View style={{ flex: 1, flexDirection: 'row' }}>
                      <Text style={{ fontWeight: 'bold' }}>Sorteio:</Text>
                      <Text>
                        {' '}
                        {moment(e.data_realizar_sorteio).format('DD/MM/YYYY')}
                      </Text>
                    </View>
                  </View>
                  <View style={{ flexDirection: 'row', marginTop: 10 }}>
                    <View style={{ flex: 1, flexDirection: 'row' }}>
                      <Text style={{ fontWeight: 'bold' }}>Modelo:</Text>
                      <Text> {e.quantidade_chance} chances</Text>
                    </View>

                    <View style={{ flex: 1, flexDirection: 'row' }}>
                      <Text style={{ fontWeight: 'bold' }}>
                        {usuario.tipo == 'VENDEDOR'
                          ? 'Total vendido'
                          : 'Vendedores'}
                        :
                      </Text>
                      <Text>
                        {' '}
                        {usuario.tipo == 'VENDEDOR'
                          ? `R$ ${formatCurrency(
                              e.valor_cartela * e.quantidade_vendido
                            )}`
                          : e.quantidade_vendedores}
                      </Text>
                    </View>
                  </View>

                  <Text
                    style={{
                      fontSize: 18,
                      textAlign: 'center',
                      marginTop: 15,
                      color: '#1abc9c',
                      fontWeight: 'bold',
                    }}
                  >
                    {e.numero_sorteado}
                  </Text>

                  {e.situacao == 'FINALIZADO' && e.numero_sorteado == null && (
                    <Text
                      style={{
                        fontSize: 18,
                        textAlign: 'center',
                        marginTop: 5,
                        color: '#e74c3c',
                        fontWeight: 'bold',
                      }}
                    >
                      NENHUM GANHADOR
                    </Text>
                  )}

                  {e.situacao == 'CANCELADO' && (
                    <Text
                      style={{
                        fontSize: 18,
                        textAlign: 'center',
                        marginTop: 5,
                        color: '#e74c3c',
                        fontWeight: 'bold',
                      }}
                    >
                      CANCELADO
                    </Text>
                  )}

                  {e.situacao == 'FINALIZADO' && e.numero_sorteado != null && (
                    <View style={{ flexDirection: 'row', marginTop: 15 }}>
                      <View style={{ flex: 1 }}>
                        <Text style={{ fontWeight: 'bold', fontSize: 12 }}>
                          Ganhador
                        </Text>
                      </View>
                      <View style={{ flex: 1 }}>
                        <Text
                          style={{
                            fontWeight: 'bold',
                            fontSize: 12,
                            textAlign: 'center',
                          }}
                        >
                          Contato
                        </Text>
                      </View>
                      <View style={{ flex: 1 }}>
                        <Text
                          style={{
                            fontWeight: 'bold',
                            fontSize: 12,
                            textAlign: 'right',
                          }}
                        >
                          Vendedor
                        </Text>
                      </View>
                    </View>
                  )}

                  {e.situacao == 'FINALIZADO' && e.numero_sorteado != null && (
                    <View style={{ flexDirection: 'row', marginTop: 5 }}>
                      <View style={{ flex: 1 }}>
                        <Text style={{ fontSize: 12 }}>
                          {e.cliente_ganhador?.nome || 'N/A'}
                        </Text>
                      </View>
                      <View style={{ flex: 1 }}>
                        <Text style={{ fontSize: 12, textAlign: 'center' }}>
                          {e.cliente_ganhador?.whatsapp || 'N/A'}
                        </Text>
                      </View>

                      <View style={{ flex: 1 }}>
                        <Text style={{ fontSize: 12, textAlign: 'right' }}>
                          {e.cliente_ganhador?.vendedor?.nome || 'N/A'}
                        </Text>
                      </View>
                    </View>
                  )}

                  <View style={{ flexDirection: 'row', marginTop: 10 }}>
                    <TouchableOpacity
                      style={{ flex: 1, marginRight: 5 }}
                      onPress={() =>
                        navigation.navigate('Relatorio', { sorteio: e })
                      }
                    >
                      <Text
                        style={{
                          textAlign: 'center',
                          fontSize: 11,
                          padding: 2.5,
                          borderRadius: 5,
                          backgroundColor: '#1abc9c',
                          color: '#FFF',
                        }}
                      >
                        Ver relatório
                      </Text>
                    </TouchableOpacity>

                    <TouchableOpacity
                      style={{ flex: 1, marginLeft: 5 }}
                      onPress={() => excluirSorteio(e)}
                    >
                      <Text
                        style={{
                          textAlign: 'center',
                          fontSize: 11,
                          padding: 2.5,
                          borderRadius: 5,
                          backgroundColor: '#e74c3c',
                          color: '#FFF',
                        }}
                      >
                        Excluir Sorteio
                      </Text>
                    </TouchableOpacity>
                  </View>
                </View>
              </View>
            ))
          ) : (
            <View
              style={{
                backgroundColor: '#fff',
                padding: 10,
                marginTop: 10,
                borderRadius: 5,
                flexDirection: 'row',
              }}
            >
              <Text style={{ flex: 1, textAlign: 'center' }}>
                Nenhum sorteio encontrado
              </Text>
            </View>
          )}
        </ScrollView>
      </View>

      {(usuario.tipo == 'ADMIN' || usuario.tipo == 'GERENTE') && (
        <FloatingAction
          color="#1abc9c"
          showBackground={false}
          animated={false}
          onPressMain={() => abrirCadastro()}
        />
      )}
    </View>
  );
};

export default Sorteios;
